module.exports = __webpack_public_path__ + "static/media/ic-manager.bf0db07b.png";